import React from "react";
import Navbar from "./Navbar";
import { Box } from "@mui/material";

const Layout = ({ children }) => (
  <>
    {/* <Navbar /> */}
    <Box>{children}</Box>
  </>
);

export default Layout;
